module.exports = new __parcel__URL__("softcomputers_booklet1.64026890.jpg").toString();